// src/pages/settings/appointments/AppointmentTypesTab.tsx
//
// S4 (ClickUp 86d42twq8) — converted from the standalone `/settings/appointment-types`
// route (`AppointmentSettingsPage.tsx`) into the settings drawer's CLINICAL group. `Layout`
// and `PageContainer` are stripped; the internal `Tabs` are unchanged.
//
// ⚠️ Named the same as `./tabs/AppointmentTypesTab` (a different component — the nested
// "Appointment Types" tab this page hosts) by coincidence of the drawer registry's tab
// label. Imported under an alias below to keep the two apart.
import React, { useState } from "react";
import { Tabs } from "antd";
import { CalendarOutlined, SettingOutlined } from "@ant-design/icons";
import AppointmentTypesInnerTab from "./tabs/AppointmentTypesTab";
import AppointmentSettingsTab from "./tabs/AppointmentSettingsTab";

const AppointmentTypesTab: React.FC = () => {
	const [activeTab, setActiveTab] = useState<string>("types");

	return (
		<Tabs
			activeKey={activeTab}
			onChange={setActiveTab}
			items={[
				{
					key: "types",
					label: <><CalendarOutlined /> Appointment Types</>,
					children: <AppointmentTypesInnerTab />,
				},
				{
					key: "settings",
					label: <><SettingOutlined /> General Settings</>,
					children: <AppointmentSettingsTab />,
				},
			]}
		/>
	);
};

export default AppointmentTypesTab;
